import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-expand",
  "use": "arrow-expand-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-expand\"><path fill=\"currentColor\" d=\"M13.68 9v6h3l-4 4-4-4h3V9h-3l4-4 4 4h-3Zm-9-7h16v2h-16V2Zm0 18h16v2h-16v-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol